import React from 'react';
import './styles.css';

import { CircularProgress, Typography } from '@mui/material';

export const LoadingPage = () => (
    <div className='loading-container'>
        <CircularProgress style={{color: "#ffffff"}} size={100} />
        <Typography variant="h2" sx={{ paddingTop: "5%", fontSize: 34, lineHeight: 1.15, marginBottom: "1%", fontWeight: 800, color: "#999999" }}>Loading...</Typography>
    </div>
)